import { Typography } from 'antd';
import type { TextProps } from 'antd/es/typography/Text';
import type { ReactNode } from 'react';

interface SecondaryLabelProps extends TextProps {
  children: ReactNode;
  currencyLabel?: boolean;
  className?: string;
  dataTestID?: string;
}

const SecondaryLabel = ({
  children,
  currencyLabel,
  className = '',
  onClick = () => {},
  ellipsis = false,
  dataTestID = '',
}: SecondaryLabelProps) => {
  return (
    <Typography.Text
      onClick={onClick}
      className={`address-text ${className} ${currencyLabel ? 'currency-label' : ''} `}
      {...(ellipsis ? { ellipsis } : {})}
      data-testid={dataTestID}
    >
      {children}
    </Typography.Text>
  );
};

export default SecondaryLabel;
